import { useOktaAuth } from '@okta/okta-react'
import { Navigate, Outlet } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'

export default function ProtectedRoute() {
  const { authState } = useOktaAuth()

  if (!authState) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
